import { useEffect, useState } from "react";

// Argon Dashboard 2 PRO MUI components
import ImportLeads from "0.Mine/0.Components/CRM/BulkLeads/AddBulkLeads";
import ArgonBox from "components/ArgonBox";

// Argon Dashboard 2 PRO MUI example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import BusinessNavbar from "examples/Navbars/DashboardNavbar/businessNavbar";

function AddBulkLeads() {
  return (
    <DashboardLayout>
      <AddBulkLeadsWithContext />
    </DashboardLayout>
  );
}

function AddBulkLeadsWithContext() {
  return (
    <ArgonBox py={3}>
      <BusinessNavbar />
      <ArgonBox py={3}>
        <ImportLeads />
      </ArgonBox>
      <Footer />
    </ArgonBox>
  );
}

export default AddBulkLeads;
